import React from "react";
import { Box, Paper } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import DescriptionIcon from "@mui/icons-material/Description";

import { SectionTitle } from "./StyledComponents";

/**
 * MealPlanDescription component displays the meal plan description
 *
 * @param {string} description - The markdown formatted description
 */
const MealPlanDescription = ({ description }) => {
  if (!description) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <SectionTitle variant="h5">
        <DescriptionIcon />
        Description
      </SectionTitle>
      <Paper
        variant="outlined"
        sx={{
          borderRadius: 2,
          p: 2,
          mt: 2,
          backgroundColor: "background.paper",
        }}
      >
        <Box
          sx={{
            "& p": {
              mb: 2,
              lineHeight: 1.6,
            },
            "& ol, & ul": {
              pl: 2,
              mb: 2,
              "& li": {
                mb: 1.5,
                pb: 0.5,
              },
            },
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          <ReactMarkdown
            remarkPlugins={[remarkGfm, remarkBreaks]}
            components={{
              p: (props) => <p style={{ whiteSpace: "pre-wrap" }} {...props} />,
            }}
          >
            {description || ""}
          </ReactMarkdown>
        </Box>
      </Paper>
    </Box>
  );
};

export default MealPlanDescription;
